export default __webpack_public_path__ + "media/images/features/ana/head_right-91cdcc163b4a4c77193a76024fabc92d.png";